export default __webpack_public_path__ + "static/media/img-0323-madagascar-premium-face.fba70c18.png";